import React from 'react';
import { Eye, X } from 'lucide-react';
import { useWatch } from '../../contexts/WatchContext';

const WatchedUserIndicator = () => {
  const { isWatching, watchedUser, stopWatching } = useWatch();

  if (!isWatching || !watchedUser) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="bg-orange-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-3 animate-pulse">
        <Eye className="w-4 h-4" />
        <div className="flex flex-col">
          <span className="text-sm font-medium">Watching User</span>
          <span className="text-xs opacity-90">{watchedUser.displayNameOrEmail}</span>
        </div>
        <button
          onClick={stopWatching}
          className="ml-2 p-1 hover:bg-orange-600 rounded transition-colors"
          title="Stop watching"
        >
          <X className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};

export default WatchedUserIndicator; 